export default {
    packNames: (state) => {
        const obj = {}
        Object.entries(state.content).forEach(([key, value])=>{
            const match = key.match(/packages_/)
            if (match) {
                const packCode = key.replace("packages_", "")
                obj[packCode] = value
            }
        })
        return obj
    },
}